export default __webpack_public_path__ + "static/media/step_3.ffbe4cd6.svg";